import { render, staticRenderFns } from "./OrganizationTabInformation.vue?vue&type=template&id=0b90370f"
import script from "./OrganizationTabInformation.vue?vue&type=script&lang=js"
export * from "./OrganizationTabInformation.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTabInformation.vue?vue&type=style&index=0&id=0b90370f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports